// Only allows letters (including accented/international), hyphens, apostrophes, and spaces
const NAME_REGEX = /^[\p{L}\s'\-]+$/u;

export function validateName(value: string | undefined, errorMessage: string): string | true {
  const trimmed = value?.trim();

  if (!trimmed) return true; // required is handled separately by the form

  if (!NAME_REGEX.test(trimmed)) return errorMessage;

  return true;
}

export default validateName;
